import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const jaegerCustomPlugin = createPlugin({
  id: 'jaeger-custom',
  routes: {
    root: rootRouteRef,
  },
});


export const TraceDetailPage = jaegerCustomPlugin.provide(
  createRoutableExtension({
    name: 'TraceDetailPage',
    component: () =>
      import('./components/TraceDetailPage').then(m => m.TraceDetailPage),
    mountPoint: rootRouteRef,
  }),
);

export const SearchTraceListPage = jaegerCustomPlugin.provide(
  createRoutableExtension({
    name: 'SearchTraceListPage',
    component: () =>
      import('./components/SearchTraceListPage').then(m => m.SearchTraceListPage),
    mountPoint: rootRouteRef,
  }),
);
